var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"mbs-no-highlight"},[_c('v-layout',{attrs:{"fill-height":""}},[(_vm.show)?_c('ActivityShow'):_c('ActivityMain')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }